import { render, staticRenderFns } from "./SettingLayout.vue?vue&type=template&id=18576587&scoped=true&"
import script from "./SettingLayout.vue?vue&type=script&lang=js&"
export * from "./SettingLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingLayout.vue?vue&type=style&index=0&id=18576587&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18576587",
  null
  
)

export default component.exports